<template>
  <el-dialog title="修改密码" width="360px" :visible.sync="showDialog" @close="handleClose" :modal-append-to-body="false" v-dialogDrag>
    <div class="reason-box" v-show="passwordPolicy.reasonModify">
      <span>{{ passwordPolicy.reasonModify }}</span>
    </div>
    <el-form class="pwd-form" :model="pwdForm" :rules="pwdRules" label-width="90px" label-position="right" ref="pwdForm">
      <!-- <el-form-item prop="force" v-show="false">
        <el-input type="text" v-model="passwordPolicy.isLogin"></el-input>
      </el-form-item> -->
      <el-row v-show="!passwordPolicy.isLogin">
        <el-col :span='24'>
          <el-form-item label="旧密码:" prop="pwdOld">
            <el-input size="small" type="password" v-model="pwdForm.pwdOld" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <el-form-item label="新密码:" prop="pwdNew">
            <el-input size="small" type="password" v-model="pwdForm.pwdNew" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <el-form-item label="确认密码:" prop="pwdConfirm">
            <el-input size="small" type="password" v-model="pwdForm.pwdConfirm" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="note-box">
        <ul>新密码要求如下：
          <li>密码最小长度为{{ passwordPolicy.passwordPolicyMinLength }}位</li>
          <li v-if="passwordPolicy.passwordPolicyMaxLengthEnable">密码最大长度为{{ passwordPolicy.passwordPolicyMaxLength }}位</li>
          <li>密码必须包大写英文字符、小写英文字符、数字、特殊字符</li>
          <li>密码不允许包含用户名</li>
          <li>密码不允许与历史密码相同</li>
        </ul>
      </div>
    </el-form>
    <div style="margin-top:20px">
      <center>
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleResetPassword">确 定</el-button>
      </center>
    </div>
  </el-dialog>
</template>

<script>
  import {modifyPassword, logout, updateChangePasswordTime} from '../api/Login';
export default {
  name: 'baseModifyPasswordComp',
  // 组件属性对象
  props: {
    // 同步更新父对象的属性, 是否显示修改密码对话框
    isVisible: Boolean,
    // 修改密码的入参对象，包括密码策略，用户名和当前密码等等
    passwordPolicy: Object
  },
  // 组件数据对象
  data() {
    // 校验确认密码
    const verifyPwdConfirm = (rule, value, callback) => {
      if (value !== this.pwdForm.pwdNew) {
        callback(new Error('与新密码不一致'));
      } else {
        callback();
      }
    };
    // 校验新密码
    const verifyPwdNew = (rule, value, callback) => {
      if (value.indexOf(this.passwordPolicy.username) > -1) {
        callback(new Error('密码不允许包含用户名'))
        return
      }
      if (value === this.pwdForm.pwdOld) {
        callback(new Error('新密码不允许和旧密码一样'))
        return
      }
      let reg = /[a-z,A-Z]/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含字母'))
        return
      }
      reg = /[a-z]/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含小写字母'))
        return
      }
      reg = /[A-Z]/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含大写字母'))
        return
      }
      reg = /\d/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含数字'))
        return
      }
      // eslint-disable-next-line
      reg = /[~`!@#$%^&*=()\-+_|\[\]\{\}:;<>,.?'"/\\]/
      if (!reg.test(value)) {
        callback(new Error('密码必须包含特殊字符, 例如：@#&%+'))
        return
      }
      callback()
    }
    return {
      showDialog: true,
      pwdForm: {
        force: this.passwordPolicy.isLogin,
        pwdOld: this.passwordPolicy.password,
        pwdNew: '',
        pwdConfirm: ''
      },
      pwdRules: {
        pwdOld: [
          {
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }
          // ,
          // {
          //   min: this.passwordPolicy.passwordPolicyMinLength,
          //   max: this.passwordPolicy.passwordPolicyMaxLength,
          //   message: `长度在【${this.passwordPolicy.passwordPolicyMinLength}】到【${this.passwordPolicy.passwordPolicyMaxLength}】个字符`
          // }
        ],
        pwdNew: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            min: this.passwordPolicy.passwordPolicyMinLength,
            max: this.passwordPolicy.passwordPolicyMaxLength,
            message: `长度在【${this.passwordPolicy.passwordPolicyMinLength}】到【${this.passwordPolicy.passwordPolicyMaxLength}】个字符`
          },
          {
            validator: verifyPwdNew,
            trigger: 'blur'
          }
        ],
        pwdConfirm: [
          {
            required: true,
            message: '请确认新密码',
            trigger: 'blur'
          },
          {
            min: this.passwordPolicy.passwordPolicyMinLength,
            max: this.passwordPolicy.passwordPolicyMaxLength,
            message: `长度在【${this.passwordPolicy.passwordPolicyMinLength}】到【${this.passwordPolicy.passwordPolicyMaxLength}】个字符`
          },
          {
            validator: verifyPwdConfirm,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  // 组件方法集合
  methods: {
    // 统一关闭密码框方法事件
    handleClose() {
      this.showDialog = false
      if (this.passwordPolicy.isLogin) {
        logout().then(result => {
          sessionStorage.removeItem('token')
        })
      }
      // 子组件向父组件绑定的属性传值
      this.$emit('update:isVisible', this.showDialog)
    },
    // 保存密码修改的结果
    handleResetPassword() {
      this.$refs.pwdForm.validate(valid => {
        if (valid) {
          // 组装向后台发送的参数
          let param = {
            //force: this.pwdForm.force,
            force: true,
            // 新密码
            newPasswd: this.pwdForm.pwdNew,
            // 旧密码，主要用户判断输入的旧密码是否正确
            originalPasswd: this.pwdForm.pwdOld
          };
          // 调用密码修改接口
          modifyPassword(param).then(result => {
            if (result.code === 20000) {
              logout().then(result => {
                sessionStorage.removeItem('token')
              })
              this.$alert('请使用新密码重新登录', '密码修改成功', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  window.location.href = '/';
                }
              })
              const param = JSON.parse(sessionStorage.getItem('param'));
              var params = {"username":param.account};
              updateChangePasswordTime(params);
            } else {
              this.$message({
                type: 'warning',
                message: result.msg
              });
            }
          })
        }
      });

    }
  }
};
</script>

<style lang="scss">
.reason-box {
  color: red;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 12px;
}

.note-box {
  margin-left: 30px;
  ul {
    margin: 0px;
  }
}

.pwd-form {
  .el-form-item {
    margin-bottom: 1px;
  }
}
</style>
